/**
 * Create i18n configuration for Radiant Media Player.
 *
 * @param    {app.i18n.I18nService}  i18nService  The i18n service
 * @returns  {Object}                The i18n config
 */
module.exports = function(i18nService) {
    var setup = {};

    switch (i18nService.get("language")) {
        case "nl":
            setup.fixedLabelsLanguage = "dutch";
            break;
        case "de":
            setup.fixedLabelsLanguage = "german";
            break;
        default:
        case "en":
            setup.fixedLabelsLanguage = "english";
            break;
    }
    setup.labels                            = {};
    setup.labels[setup.fixedLabelsLanguage] = i18nService.getTranslation("RadiantMP");

    return setup;
};
